import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'

export const useDeleteGeneratedAttachmentMutation = (
  applicantId: number | undefined
) => {
  const queryClient = useQueryClient()

  return useMutation<void, ApiResponseError, number>({
    mutationFn: (attachmentId) =>
      fetchApiWithToken<void>({
        method: 'delete',
        url: `/v1/attachments/${attachmentId}`
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['applicants', applicantId, 'attachments']
      })
    }
  })
}
